module.exports = __webpack_public_path__ + "static/Aeroseal_Masthead_Commercial-f68df1a0ef5ab4118a2d811420d39a7c.jpg";